/**
 * @author       yontaek@zumper.com (Yon Taek Chung)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  DetailSaveSearch
 */
import { Box } from '@chakra-ui/react'
import { bellOutlineWhite } from '@zcode-ui/icons'
import { selectEntity, selectIsAddressOnBuilding } from '@zcode-ui/web-zumper-global-state'
import { Origin, localStorageSingleton } from '@zcode/nr-utils'
import React from 'react'
import { useSelector } from 'react-redux'
import { SaveSearchButtonContainer } from '../../components/SaveSearch/SaveSearchButtonContainer'

export const DetailSaveSearchButton = () => {
  const entity = useSelector(selectEntity)
  const savedSearchIds = localStorageSingleton.get('savedSearchEntityIds') ?? []
  const { groupId } = entity ?? {}
  const isAddressOnBuilding = useSelector(selectIsAddressOnBuilding)
  const shouldDisable = savedSearchIds.includes(groupId)
  return (
    <SaveSearchButtonContainer
      buttonProps={{ className: 'h-12 mb-2 w-full', size: 'lg', variant: 'solid' }}
      disabled={shouldDisable}
      hasTooltip={false}
      hideContainerClass
      noIcon
      origin={
        isAddressOnBuilding ? Origin.ADDR_DETAIL_TOP_RIGHT_RAIL : Origin.DETAIL_TOP_RIGHT_RAIL
      }
      text={
        <Box<'div'>
          alignItems="center"
          display="flex"
          fontSize="md"
          fontWeight="bold"
          gap="4px"
          width="100%"
        >
          <img alt="bell" loading="lazy" src={bellOutlineWhite} />
          {shouldDisable ? 'Search saved' : 'Save search'}
        </Box>
      }
    />
  )
}
